@if (profile) {
    <main class="mediumContainer">
        <div class="d-flex flex-row">
            <button (click)="back()" (keyup.enter)="back()" aria-label="Back" mat-icon-button matTooltip="Back">
                <mat-icon>keyboard_backspace</mat-icon>
            </button>
        </div>
        <h1 class="cdk-visually-hidden">{{ profile | nameDisplay }}'s profile</h1>
        <div class="profileContainer">
            <div>
                <mat-card>
                    @if (!canEditProfilePicture) {
                        <img [src]="profile.photo ||  'assets/images/blankProfile.png'"
                             alt="Photo of {{ profile| nameDisplay: undefined: undefined: 'profile' }}"
                             class="squareImage" mat-card-image>
                    }
                    @if (canEditProfilePicture) {
                        <div class="pb-10">
                            @if (showCropper) {
                                <div>
                                    <image-cropper
                                            (imageCropped)="imageCropped($event)"
                                            [aspectRatio]="1"
                                            [imageChangedEvent]="imageChangedEvent"
                                            [maintainAspectRatio]="true"
                                            [resizeToWidth]="250"
                                            format="png"
                                    ></image-cropper>
                                </div>
                            }
                            @if (!showCropper) {
                                <img [src]="imgURL" alt="Profile Picture" class="w-100 imgControl">
                            }
                            @if (isRaaAdoptiveFamilyPictureOnlyMode) {
                                <p class="text-center mb-10"><strong>{{ profile.first_name }}</strong></p>
                            }
                            <div class="flex-row flex-space-around">
                                @if (!showCropper) {
                                    <div>
                                        <button (click)="fileInput.click()" (keyup.enter)="fileInput.click()"
                                                color="primary" mat-raised-button>
                                            <span>Select New Profile Picture</span>
                                            <input #fileInput (change)="onFileChanged($event)"
                                                   accept="image/png, image/jpeg" class="d-none"
                                                   type="file"/>
                                        </button>
                                    </div>
                                }
                                @if (imgURL != 'assets/images/blankProfile.png' && imgURL != this.profile.photo) {
                                    <div class="flex-row gap-15">
                                        <button (click)="removeImage()" color="warn" mat-raised-button>Cancel
                                        </button>
                                        <button (click)="saveProfilePic()" color="accent"
                                                mat-raised-button>
                                            Upload
                                        </button>
                                    </div>
                                }
                            </div>
                        </div>
                    }
                    @if (canViewProfileDetails) {
                        <mat-card-content>
                            <p><strong>Name</strong>: {{ profile| nameDisplay: undefined: undefined: 'profile' }}
                            </p>
                            @if ("job_title" in profile) {
                                <!-- check if profile or memory box type -->
                                @if (profile.role) {
                                    <p><strong>User Role</strong>: {{ profile.role.name | removeBrackets }}
                                    </p>
                                }
                                @if (profile.job_title && user.id !== id && !isRaa) {
                                    <p>
                                        <strong>Job Title</strong>: {{ profile.job_title }}
                                    </p>
                                }
                                @if (profile.contact_number) {
                                    <p><strong>Number</strong>:
                                        <a href="tel:{{ profile.contact_number }}">{{ profile.contact_number }}</a>
                                    </p>
                                }
                                @if (profile.email) {
                                    <p><strong>Email</strong>:
                                        <a href="mailto:{{ profile.email }}">{{ profile.email }}</a>
                                    </p>
                                }
                                @if (profile.locality?.name) {
                                    <p><strong>Locality</strong>: {{ profile.locality?.name }}</p>
                                }
                            }
                            @if (profile.reference_number) {
                                <p><strong>Case Management Number</strong>: {{ profile.reference_number }}
                                </p>
                            }

                            @if (profile.dob) {
                                <p><strong>Date of Birth</strong>: {{ profile.dob | date :'dd/MM/yyyy' }}</p>
                            }
                        </mat-card-content>
                    }
                    @if (canViewProfileDetails && (timelineId || user.id == id)) {
                        <mat-card-actions class="flex-space-around btnStack mt-10">
                            @if (timelineId) {
                                <button [routerLink]="['/timeline', this.timelineId]" color="primary"
                                        mat-raised-button>View Memory Box
                                </button>
                            }
                            @if (user.id == id) {
                                <button [routerLink]="['/settings']" color="primary" mat-raised-button>Edit
                                    Profile
                                </button>
                            }
                            @if (this.timelineId && (this.user.role.can_manage_hidden_media || this.user.role.role_type == 'admin')) {
                                <button [routerLink]="['/hiddenMedias', timelineId]" color="primary"
                                        mat-raised-button>View Hidden Media
                                </button>
                            }
                        </mat-card-actions>
                    }
                </mat-card>
            </div>
            @if (canViewProfileDetails) {
                <div class="d-flex flex-col gap-15">
                    @if (profile.about_me) {
                        <mat-card>
                            <mat-card-header class="flex-space-between">
                                <mat-card-title><strong>About Me</strong></mat-card-title>
                            </mat-card-header>
                            <mat-card-content>
                                <p>{{ profile.about_me }}</p>
                            </mat-card-content>
                        </mat-card>
                    }
                    @if (((this.user.role.role_type == 'adult' && this.user.role.name != 'Birth Family' && this.permissions) || this.user.role.role_type == 'admin' || profile.id == user.id) && this.timelineId) {
                        <mat-card>
                            <mat-card-header class="fullWidth">
                                <mat-card-title class="w-100">
                                    <div class="d-flex flex-space-between w-100 align-items-center">Permissions
                                        @if (this.user.role.role_type == 'admin' || this.user.role.can_add_permissions) {
                                            <button (click)="newRelationship()" color="primary" mat-raised-button
                                                    matTooltip="Add new permission">
                                                Add new permission
                                                <mat-icon>add</mat-icon>
                                            </button>
                                        }
                                    </div>
                                </mat-card-title>
                            </mat-card-header>
                            <mat-card-content>
                                <app-manage-access-table
                                        (updatePermissions)="refreshTimelinePermissions()"
                                        [canRequest]="this.user.role.can_edit_permissions|| this.user.role.role_type == 'admin'"
                                        [child]="profile.id"
                                        [isProfile]="isProfile()"
                                        [myMemoryBox]="true"
                                        [permissions]="permissions || []"
                                        [timelineName]="profileDisplayName()"
                                        [timeline]="this.timelineId"></app-manage-access-table>
                            </mat-card-content>
                        </mat-card>
                    }
                </div>
            }
        </div>
    </main>
}

@if (!profile) {
    <div class="centerLoading">
        <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
    </div>
}
